export const _CALENDAR_FALL_2026_08_24_16 = { 
	'description':'Fall 2026',
	'meetingDates':'Monday, August 24th through Friday, December 11th',
	'sprintDates': [
		// Sprint 1
		{ 	'start':'Mon Aug 24 2026 08:00:00 GMT-0500', 
			'end':'Sun Sep 06 2026 23:59:00 GMT-0600', 
			'notes':'',
			'schedule' : [ 
				{ activity:'Introductions and Sprint Planning', day: 1 },
				{ activity:'Sprint Planning (continued) and Lab', day: 3 },
				{ activity:'Topic Discussion and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 2	
		{ 	'start':'Mon Sep 07 2026 08:00:00 GMT-0500', 
			'end':'Sun Sep 20 2026 23:59:00 GMT-0600', 
			'notes':'Labor Day',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Topic Discussion, Lab, and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 3
		{ 	'start':'Mon Sep 21 2026 08:00:00 GMT-0500', 
			'end':'Sun Oct 04 2026 23:59:00 GMT-0600', 
			'notes':'',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Topic Discussion, Lab, and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 4
		{	'start':'Mon Oct 05 2026 08:00:00 GMT-0500', 
			'end':'Sun Oct 18 2026 23:59:00 GMT-0600', 
			'notes':'Fall Break',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Topic Discussion, Lab, and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 5
		{	'start':'Mon Oct 19 2026 08:00:00 GMT-0500', 
			'end':'Sun Nov 01 2026 23:59:00 GMT-0600', 
			'notes':'Midterm Exam',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Midterm Exam & Lab', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 6
		{	'start':'Mon Nov 02 2026 08:00:00 GMT-0500', 
			'end':'Sun Nov 15 2026 23:59:00 GMT-0600', 
			'notes':'',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Topic Discussion, Lab, and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 7
		{'start':'Mon Nov 16 2026 08:00:00 GMT-0500', 
			'end':'Sun Dec 06 2026 23:59:00 GMT-0600', 
			'notes':'Final Exam and Thanksgiving Holiday',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Topic Discussion, Lab, and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		},

		// Sprint 8
		{	'start':'Mon Dec 07 2026 08:00:00 GMT-0500', 
			'end':'Wed Dec 09 2026 23:59:00 GMT-0600', 
			'notes':'Presentations',
			'schedule': [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospectives, Discussion Board, and Lab', day: 3 },
				{ activity:'Topic Discussion, Lab, and Quiz', day: 8 },
				{ activity:'Topic Discussion and Lab', day: 10 },
				{ activity:'All Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Assignments Due', day: 13 } ],
		}
	]
}

// The following calendars are for the two Fall 2025 8 week sessions with starts on October 20th and ends on December 12th.
export const _CALENDAR_FALL_2025_08_25_08 = { 
	'description':'Fall 2025',
	'meetingDates':'Monday, August 25th through Friday, December 12th',
	'sprintDates': [
		{ 'start':'Mon Aug 25 2025 08:00:00 GMT-0500', 'end':'Sun Aug 31 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Sep 01 2025 08:00:00 GMT-0500', 'end':'Sun Sep 07 2025 23:59:00 GMT-0600', 'notes':'Labor Day' },
		{ 'start':'Mon Sep 08 2025 08:00:00 GMT-0500', 'end':'Sun Sep 14 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Sep 15 2025 08:00:00 GMT-0500', 'end':'Sun Sep 21 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Sep 22 2025 08:00:00 GMT-0500', 'end':'Sun Sep 28 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Sep 29 2025 08:00:00 GMT-0500', 'end':'Sun Oct 05 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Oct 06 2025 08:00:00 GMT-0500', 'end':'Sun Oct 12 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Oct 13 2025 08:00:00 GMT-0500', 'end':'Sun Oct 19 2025 23:59:00 GMT-0600', 'notes':'' }
	]
}

export const _CALENDAR_FALL_2025_10_20_08 = { 
	'description':'Fall 2025',
	'meetingDates':'Monday, October 20th through Friday, December 12th',
	'sprintDates': [
		{ 'start':'Mon Oct 20 2025 08:00:00 GMT-0500', 'end':'Sun Oct 26 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Oct 27 2025 08:00:00 GMT-0500', 'end':'Sun Nov 02 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Nov 03 2025 08:00:00 GMT-0500', 'end':'Sun Nov 09 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Nov 10 2025 08:00:00 GMT-0500', 'end':'Sun Nov 16 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Nov 17 2025 08:00:00 GMT-0500', 'end':'Sun Nov 23 2025 23:59:00 GMT-0600', 'notes':'Midterm Exam' },
		{ 'start':'Mon Nov 24 2025 08:00:00 GMT-0500', 'end':'Sun Nov 30 2025 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Dec 01 2025 08:00:00 GMT-0500', 'end':'Sun Dec 07 2025 23:59:00 GMT-0600', 'notes':'Final Exam' },
		{ 'start':'Mon Dec 08 2025 08:00:00 GMT-0500', 'end':'Wed Dec 10 2025 23:59:00 GMT-0600', 'notes':'Presentations' }
	]
}

export const _CALENDAR_SPRING_2026_01_20_16 = { 
	'description':'Spring 2026',
	'meetingDates':'Monday, January 20th through Friday, May 16th',
	'sprintDates': [
		{ 'start':'Mon Jan 19 2026 08:00:00 GMT-0500', 'end':'Sun Feb 01 2026 23:59:00 GMT-0600', 'notes':'Martin Luther King Day' },
		{ 'start':'Mon Feb 02 2026 08:00:00 GMT-0500', 'end':'Sun Feb 15 2026 23:59:00 GMT-0600', 'notes':'' },
		{ 'start':'Mon Feb 16 2026 08:00:00 GMT-0500', 'end':'Sun Mar 01 2026 23:59:00 GMT-0600', 'notes':'' },

		// Sprint 4
		{ 	'start':'Mon Mar 02 2026 08:00:00 GMT-0500', 
			'end':'Sun Mar 29 2026 23:59:00 GMT-0600', 
			'notes':'Spring Break, Midterm, and schedule challenges',
			'schedule': [
				{ activity:'Sprint Planning (asynchronous)', day: 1 },
				{ activity:'Lab (asynchronous)', day: 3 },
				{ activity:'Lab', day: 8 },
				{ activity:'Demos and Retrospectives', day: 10 },
				{ activity:'No Class: Spring Break', day: 15 },
				{ activity:'No Class: Sprint Break', day: 17 },
				{ activity:'Lab', day: 22 },
				{ activity:'Midterm Exam (asynchronous)', day: 24 },
				{ activity:'All Sprint 4 Assignments Due', day: 27 } ] },
		
		// Sprint 5
		{ 	'start':'Mon Mar 30 2026 08:00:00 GMT-0500', 
			'end':'Sun Apr 12 2026 23:59:00 GMT-0600', 
			'notes':'Easter Break', 
			'schedule' : [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'No Class: Easter Break', day: 3 },
				{ activity:'Demos and Retrospectives', day: 8 },
				{ activity:'Lab', day: 10 },
				{ activity:'All Sprint 5 Assignments Due', day: 13 } ] },

		// Sprint 6
		{ 'start':'Mon Apr 13 2026 08:00:00 GMT-0500', 
			'end':'Sun Apr 26 2026 23:59:00 GMT-0600', 
			'notes':'',
			'schedule' : [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospective, and Discussion', day: 3 },
				{ activity:'Topic, Lab, and Quiz', day: 8 },
				{ activity:'Topic and Lab', day: 10 },
				{ activity:'All Sprint 6 Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Sprint 6 Assignments Due', day: 13 } ],
		},

		// Sprint 7
		{ 'start':'Mon Apr 27 2026 08:00:00 GMT-0500', 
			'end':'Sun May 10 2026 23:59:00 GMT-0600', 
			'notes':'Class Project and Final Exam',
			'schedule' : [ 
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Demos, Retrospective, and Discussion', day: 3 },
				{ activity:'Final Exam with in person attendance required', day: 8 },
				{ activity:'Topic and Lab', day: 10 },
				{ activity:'All Sprint 7 Assignments Due', day: 13 } ],
			'scheduleT': [
				{ activity:'Sprint Planning', day: 1 },
				{ activity:'Scrum Team Meeting', day: 8 },
				{ activity:'All Sprint 6 Assignments Due', day: 13 } ],
		},

		// Sprint 8
		{ 'start':'Mon May 11 2026 08:00:00 GMT-0500', 
			'end':'Wed May 13 2026 23:59:00 GMT-0600', 
			'notes':'Class Project Presentation',
			'schedule' : [
				{ activity:'Class Project Presentation', day: 0 } ],
			'scheduleT': [
				{ activity:'Class Project Presentation', day: 0 } ],

		}
	]
}